<template>
  <v-row justify="center" :class="[(mode === 'edit') ? 'margenes': '']">
    <v-col cols="12" md="6">
      <v-card class="v-card--material pa-3">
        <v-card-title>Datos recibo</v-card-title>
        <v-row>
          <v-col cols="12" class="pb-0">
            <validation-provider v-slot="{ errors }" name="notas" rules="max:250">
              <v-textarea v-model="dataForm.nota" color="gold" counter rows="3" :error-messages="errors" name="input-6-2" label="Notas" @blur="enviarRAPadre" />
            </validation-provider>
          </v-col>
          <v-col cols="12" class="pt-0">
            <validation-provider v-slot="{ errors }" name="observaciones" rules="max:250">
              <v-textarea v-model="dataForm.obs" color="gold" counter rows="3" :error-messages="errors" name="input-6-3" label="Observaciones (no imprimible)" @blur="enviarRAPadre" />
            </validation-provider>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu ref="fechaRecibo" v-model="fechaRecibo" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="dataForm.fecha" prepend-inner-icon="mdi-calendar-outline" color="gold" label="Fecha" readonly v-on="on" />
              </template>
              <v-date-picker v-model="dataForm.fecha" color="gold" landscape scrollable locale="es-419" no-title @input="enviarRAPadre" />
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <base-upload-files folder="/documentaciones/facturacion" label-text="Recibo" tipo="pdf" :documento-id="dataForm.documentacion_id" @documento="agregarDocumentacionRecibo($event)" />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card class="v-card--material pa-3">
        <v-card-title>Datos factura</v-card-title>
        <v-row>
          <v-col cols="12" class="mb-4">
            <v-select v-model="tipoFacturaSelected" color="gold" :items="tipoFactura" label="Tipo de factura" return-object item-text="codigo" @blur="enviarFAPadre">
              <template v-slot:item="{ attrs, item, on }">
                <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.codigo" />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" class="mb-6">
            <validation-provider v-slot="{ errors }" name="número de factura" rules="max:15">
              <v-text-field v-model="dataForm.factura.numero" color="gold" :error-messages="errors" label="Factura número" :disabled="(tipoFacturaSelected.defaul_cobros_sn === 0) ? false : true" @blur="enviarFAPadre" />
            </validation-provider>
          </v-col>
          <v-col cols="12" md="6" class="pt-5 mb-3">
            <v-menu ref="fechaFactura" v-model="fechaFactura" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="dataForm.factura.fecha" prepend-inner-icon="mdi-calendar-outline" color="gold" label="Fecha" readonly v-on="on" />
              </template>
              <v-date-picker v-model="dataForm.factura.fecha" color="gold" landscape scrollable locale="es-419" no-title @input="enviarFAPadre" />
            </v-menu>
          </v-col>
          <v-col cols="12" md="6" class="pt-5 mb-3">
            <base-upload-files folder="/documentaciones/facturacion" label-text="Factura" tipo="pdf" :documento-id="dataForm.factura.documentacion_id" @documento="agregarDocumentacionFactura($event)" />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col v-if="mode === 'edit'" cols="auto">
      <v-btn color="gold" dark @click="aplicarCambios()">
        Aplicar
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    name: 'FacturaRecibos',
    props: {
      id: {
        type: Number,
        default: 0,
        required: false,
      },
      mode: {
        type: String,
        default: 'new',
        required: true,
      },
      datosRecibo: {
        type: Object,
        required: false,
        default: null,
      },
      datosFactura: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data () {
      return {
        fechaRecibo: false,
        fechaFactura: false,
        tipoFacturaSelected: {
          defaul_cobros_sn: 0,
        },
        tipoFactura: [],
        dataForm: {
          documentacion_id: null,
          factura: {
            documentacion_id: null,
          },
        },
      }
    },
    computed: {},
    watch: {
      tipoFacturaSelected () {
        if (this.mode === 'edit') {
          if (this.tipoFacturaSelected !== this.tipoOriginal) {
            this.dataForm.tipo_factura_id = this.tipoFacturaSelected.id
          }
        } else {
          if (this.tipoFacturaSelected.defaul_cobros_sn === 1) {
            this.dataForm.factura.numero = this.tipoFacturaSelected.numero_actual + 1
            this.dataForm.tipo_factura_id = this.tipoFacturaSelected.id
          } else {
            this.dataForm.factura.numero = ''
            this.dataForm.tipo_factura_id = this.tipoFacturaSelected.id
          }
        }
        this.enviarFAPadre()
      },
    },
    created () {
      this.updateTiposFactura()
      if (this.id !== 0) {
        this.getRecibo()
      } else {
        this.iniciarNuevo()
      }
    },
    methods: {
      /*
      cambioFechaFactura () {
        console.log('cambioFEcha')
        this.fechaFactura = false
        this.enviarFAPadre()
      },
      cambioFechaRecibo () {
        this.fechaRecibo = false
        this.enviarRAPadre()
      },
      */
      iniciarNuevo () {
        this.dataForm = this.datosRecibo
        this.dataForm.factura = this.datosFactura
        this.dataForm.fecha = dayjs().format('YYYY-MM-DD')
        this.dataForm.factura.fecha = dayjs().format('YYYY-MM-DD')
        this.enviarRAPadre()
        this.enviarFAPadre()
      },
      enviarRAPadre: function () {
        const recibo = {
          documentacion_id: this.dataForm.documentacion_id,
          notas: this.dataForm.nota,
          obs: this.dataForm.obs,
          fecha: this.dataForm.fecha,
        }
        this.$emit('actualizarRecibo', recibo)
      },
      enviarFAPadre: function () {
        const factura = {
          numeroFactura: this.dataForm.factura.numero,
          fechaFactura: this.dataForm.factura.fecha,
          docFactura: this.dataForm.factura.documentacion_id,
          tipo_factura_id: this.dataForm.tipo_factura_id,
        }
        this.$emit('actualizarFactura', factura)
      },
      aplicarCambios () {
        const url = '/api/recibo/' + this.id
        this.$http.put(url, this.dataForm)
          .then(response => {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['Cambios aplicados con exito'] })
            this.$router.push({ name: 'Listado de Recibos' })
          }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
      },
      getRecibo () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/recibo/' + this.id }).then(response => {
          this.dataForm = response
          this.updateTipoFactura()
        })
      },
      updateTiposFactura () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_factura' }).then(response => {
          this.tipoFactura = response
          this.tipoFacturaSelected = this.tipoFactura.find(e => e.defaul_cobros_sn === 1)
        })
      },
      updateTipoFactura () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_factura' }).then(response => {
          this.tipoFactura = response
          this.tipoFacturaSelected = this.tipoFactura.find(e => e.id === this.dataForm.factura.tipo_factura_id)
          this.tipoOriginal = this.tipoFacturaSelected
        })
      },
      agregarDocumentacionFactura (documento) {
        this.dataForm.factura.documentacion_id = documento
        this.enviarFAPadre()
      },
      agregarDocumentacionRecibo (documento) {
        this.dataForm.documentacion_id = documento
        this.enviarRAPadre()
      },
    },
  }
</script>
<style lang="sass" scoped>
  .margenes
    margin-left: 89px
    margin-top: 40px
    margin-right: 72px
    margin-bottom: 50px
</style>
